import Cookies from "js-cookie";
import ConfigCmsApi from "../configs/ConfigCmsApi";

/**
 * Image storage — the CMS side of the monolith's `media_images` table.
 * Variants are built in the browser (see pages/MediaImages/imageVariants.js) and posted as one
 * multipart request: `original` plus one file per crop suffix.
 */

const headers = () => ({ Authorization: Cookies.get("adminToken") });

const formDataOf = (variants, fields = {}) => {
  const formData = new FormData();

  Object.entries(variants).forEach(([variant, blob]) => {
    const name = blob.name || `${variant}.jpeg`;
    formData.append(variant, blob, name);
  });

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) formData.append(key, value);
  });

  return formData;
};

const list = (params) => ConfigCmsApi.get("/media-images/", { params, headers: headers() });

const upload = ({ variants, alt = "", title = "", onUploadProgress } = {}) =>
  ConfigCmsApi.post("/media-images/", formDataOf(variants, { alt, title }), {
    headers: headers(),
    onUploadProgress,
  });

const recrop = ({ id, variants, onUploadProgress } = {}) =>
  ConfigCmsApi.post(`/media-images/${id}/recrop`, formDataOf(variants), {
    headers: headers(),
    onUploadProgress,
  });

const update = ({ id, alt = "", title = "" } = {}) => {
  const formData = new FormData();
  formData.append("alt", alt);
  formData.append("title", title);

  return ConfigCmsApi.put(`/media-images/${id}`, formData, { headers: headers() });
};

const remove = (id) => ConfigCmsApi.delete(`/media-images/${id}`, { headers: headers() });

export default { list, upload, recrop, update, remove };
